import { Component } from '@angular/core';
import { CoreSeoPages } from '@app/store/enums/core-seo-pages';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-core-terms-and-conditions',
  templateUrl: './core-terms-and-conditions.component.html',
  styleUrls: ['./core-terms-and-conditions.component.scss']
})
export class CoreTermsAndConditionsComponent {

  constructor(
    private seo: SeoService
  ) {
    this.seo.generateMetaTags(CoreSeoPages.TERMS)
  }

}
